<template>
   <vue-final-modal
      v-model="affilEmail" 
      classes="modal-container"
      content-class="affil-email-modal-content"
      @opened="opened()"
      @click-outside="$emit('cancel')"
      >
      <button 
         id="first-aes"
         type="button"
         class="modal__close btn btn-sm" 
         :tabindex="tabIndexNumber(2)" 
         @click="$emit('cancel')"
         >
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg tx-cl-white" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
         </svg>
      </button>
      <span class="modal__title tx-cl-white">Emails del Afiliado</span>
      <div class="affil-email p-0 mt-1 border-top border-bottom">
         <div class="container">
            <div :tabindex="tabIndexNumber(1)" onfocus="document.getElementById('last-aes').focus()"></div>
            <div v-if=" affilId > 0 ">
               <div v-if="haveEmails" class="py-1">
                  <div v-if="email">
                     <i>Padrón:</i>
                     <div class="row p-0 pb-1 email-affil border-top"
                           @click="sendSelect(email)"
                           >
                        <div class="col-12"><b>{{email}}</b></div>
                     </div>
                  </div>
                  <!-- 
                  -->
                  <div v-if=" otherAffilEmails.length > 0" >
                     <i>Informados:</i>
                     <div class="row border-top">
                     <div v-for="(otherEmail, index) in otherAffilEmails" :key="index" 
                           class="email-affil"
                           @click="sendSelect(otherEmail)"
                           >
                        <div class="col-12"><b>{{otherEmail}}</b></div>
                     </div>
                     </div>
                  </div>
               </div>
               <div v-else class="pt-2" >
                  <p>El Afiliado no tiene registrastrados Emails! </p>
               </div>
            </div>
            <div v-else class="pt-2" >
               <p>Debe ingresarse un CUIL válido para poder ver los Emails del Afiliado!</p>
            </div>
            <!--
            <pre>{{ affilId }}</pre>
            <div v-for="(rectangleCard, index) in cellCards" :key="index" 
                  class="row p-0 py-1 ms-1 email-affil"
                  @click="sendSelect(rectangleCard.name)"
                  >
               <card-rectangle :rectangleCard="rectangleCard"  class="col-2"/>
               <div class="col-10"><b>{{rectangleCard.name}}</b></div>
                  
            </div>
            -->
         </div>
      </div>
            <div class="row p-0 justify-content-between mx-0">
               <user-circle :circleUser="myCircle" class="col-2 mt-2"/>
               <div class="d-flex justify-content-end pt-2 px-0 col-10">
                  <button type="button" 
                        id="last-aes"
                        :tabindex="tabIndexNumber(3)" 
                        class="btn btn-outline-light btn-sm me-1" 
                        @click="$emit('cancel')"
                        >
                     Salir
                  </button>
                  <div :tabindex="tabIndexNumber(4)" onfocus="document.getElementById('first-aes').focus()"></div>
               </div>
            </div>
   </vue-final-modal>
</template>

<script>


import { VueFinalModal } from 'vue-final-modal'
import { ref, computed, nextTick } from 'vue';
import { useStore } from 'vuex'

import WspService from '../../workSpace.service';

import UserCircle from '../../../../components/UserCircle.vue';
//import CardRectangle from '../CardRectangle.vue';

export default {

   components: {
      UserCircle,
      VueFinalModal,
//      CardRectangle
   },

   props: {
      affilId: Number,
      email: String
   },

   emits: [ 'cancel', 'selected' ],

   setup(props, { emit }) {

      const initialTabIndex = ref(150)
      const affilEmail = ref(true)
      const myCircle = ref({})
      const store = useStore()

      const haveEmails = ref(false)
      const otherAffilEmails = ref([])

      const currentUserId = computed(() => {
         return store.state.auth.user.id;
      })

      function opened() {
         
         haveEmails.value = props.email != null

         WspService.getOtherEmails( 'AFFIL', props.affilId )
         .then(response => {
            otherAffilEmails.value = response.data
            if ( otherAffilEmails.value.length > 0 ) {
               haveEmails.value = true
            }
         })
         .catch(error => { console.log(error) })         
         
         WspService.getMyCircle(currentUserId.value)
         .then(response => {
            myCircle.value = response.data
         })
         .catch(error => { console.log(error) })
      }

      function sendSelect( email ) {
         emit( 'selected', email)
         nextTick(() => {
            emit('cancel')
         })
      }

      function tabIndexNumber( value ) {
         return initialTabIndex.value + value
      }

      
      return {
         affilEmail,
         haveEmails,
         myCircle,
         opened, otherAffilEmails,
         sendSelect,
         tabIndexNumber,
      }
   }
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
::v-deep(.affil-email-modal-content) {
  /*
  width: 350px;
  */
  position: relative;
  display: flex;
  flex-direction: column;
  top: 5%;
  min-width: 350px;
  max-width: 750px;
  max-height: 90%;
  padding: 0.00rem 0.25rem 0.25rem 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background-color: #9E9E9E ;
}
.modal__title {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
.affil-email {
   background-color: #9E9E9E ;
   max-height: calc(100vh - 28px);
   overflow-y: auto;
   color: white;
}
.tx-cl-white {
   color: white;
}
td {
   height: 1.5rem;   
}
.email-affil {
   cursor: pointer;
}
.email-affil:hover {
   background-color: darkgrey;
}
</style>
